module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.2e90d515.woff";